/** Quem vê o SQL por trás das respostas.
 *
 *  Decisão de 07/09/2026: a linha Ver consulta é ferramenta de quem testa o
 *  assistente, não do usuário da operação. Em produção ela fica escondida, e
 *  aparece de dois jeitos: pelo ambiente, quando o deploy liga
 *  `assistenteMostrarSql` no runtime-config, ou pelo navegador, quando quem
 *  está testando grava `assistente-depurar` como `1` no localStorage. O
 *  segundo caminho existe para testar em produção sem redeploy, e vale só
 *  naquele navegador. */
export const CHAVE_DEPURAR = 'assistente-depurar'

export function podeVerSql(config: { assistenteMostrarSql?: boolean } | undefined, valorGuardado: string | null): boolean {
  if (config?.assistenteMostrarSql) return true
  return valorGuardado === '1'
}

export function depuracaoDeSqlLigada(): boolean {
  let guardado: string | null = null
  try {
    guardado = localStorage.getItem(CHAVE_DEPURAR)
  } catch {
    guardado = null
  }
  return podeVerSql(window.__TRANSGRAOS_CONFIG__, guardado)
}
